import { computed } from "vue";
import { useStore } from "vuex"
import ChatMessageToolbar from "../ChatMessageToolbar/ChatMessageToolbar.vue";
import ChatMessageCards from "../ChatMessageCards/ChatMessageCards.vue";

export default {
    name: "ChatMessage",
    components: {
        ChatMessageToolbar,
        ChatMessageCards
    },
    props: {
        labels: {
            type: Object,
        },
        appearance: {
            type: String,
            default: "default"
        },
        size: {
            type: String,
            default: "medium"
        },
        message: {
            type: Object,
            required: true
        },
        isUser: {
            type: Boolean,
            required: true
        },
    },
    setup(props, { emit }) {
        const messageClassName = computed(() => {
            const sourceClassName = props.isUser ? "nyk-chat-message__content--user" : "nyk-chat-message__content--bot"
            const messageTypeClassName = props.message.type === "statusMessage" ? "nyk-chat-message__content--status-message" :
                props.message.type === "html" ? "nyk-chat-message__content--html" :
                    props.message.type === "text" ? "nyk-chat-message__content--text" :
                        props.message.type === "links" ? "nyk-chat-message__content--links" : ""
            const messageAppearance = props.appearance === "plain" ? "nyk-chat-message__content--plain" : ""
            const messageSize = props.size === "large" ? "nyk-chat-message__content--large" : ""

            return `${sourceClassName} ${messageTypeClassName} ${messageAppearance} ${messageSize}`
        })
        const store = useStore()
        const parser = new DOMParser()

        function sendActionId(link) {
            if (!link || !link.id) return
            emit("onAction", link.id)
        }

        function sendExternalLink(payload) {
            emit("onExternalLink", payload)
        }

        function modifyHyperlinkTargets(str) {
            const doc = parser.parseFromString(str, 'text/html');
            const anchors = doc.querySelectorAll('a');
            anchors.forEach(anchor => {
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('rel', 'noopener noreferrer');
            });
            return doc.body.innerHTML;
        }

        function decodeUnicode(str) {
            if (props.size === "large") {
                str += '<span class="cursor"></span>'
                if (props.message.type === "html") {
                    str = modifyHyperlinkTargets(str);
                }
            }
            return str.replace(/\\u([\dA-F]{4})/gi, (match, grp) => {
                return String.fromCharCode(parseInt(grp, 16));
            });
        }

        const isConversationExpired = computed(() => {
            return store.getters["chatPanel/isConversationExpired"]
        })

        const handleFeedback = (feedbackPayload) => {
            emit("onFeedback", feedbackPayload);
        };

        return {
            isConversationExpired,
            decodeUnicode,
            sendActionId,
            sendExternalLink,
            handleFeedback,
            messageClassName
        }
    }
}